<script>
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  import configStore from "../../stores/config-store.js";
  const config = $configStore;

  import HeaderIntro from "../basic/HeaderIntro.svelte";
  import LoadingSpinner from "../basic/LoadingSpinner.svelte";

  export let userId;
  export let userdata;

  let redirectFlowId;
  let redirectFlowUrl;
  let state;
  let errorMsg;
  let sessionToken;

  if (
    typeof userdata.gcCustomer != "undefined" &&
    typeof userdata.gcMandate != "undefined"
  ) {
    state = 5;
  } else {
    state = 1;
  }
  //aus irgendeinem Grund funktioniert dispatch nur mit kurzem Timeout zuvor?
  setTimeout(() => {
    dispatch("newPaymentResult", { state: state });
  }, 1000);

  /*
    1 = Prozess nicht gestartet
    2 = Prozess erfolgreich bei GC erstellt, aber noch nicht durch Nutzer ausgeführt
    3 = erfolgreich bestätigt
    4 = Error, ggf zurück zu 1
    5 = Lastschriftmandat bereits vorhanden
  */

  
  //replace backend URL with ws:// or wss://
  /*
  var wSocket = new WebSocket(config.urls.backend.replace(/^http/, "ws"));

  wSocket.onmessage = function (event) {
    let resData = JSON.parse(event.data);
    switch (resData.type) {
      case "redirectFlowCompleted":
        console.log(resData.redirectFlow);
        state = 3;
        dispatch("newPaymentResult", { state: state });
        wSocket.close();
        break;
      case "redirectFlowUnknownError":
        console.log(resData.errors);
        errorMsg = resData.errorObj.msgDe;
        state = 4;
        dispatch("newPaymentResult", { state: state });
        alert(`ERROR: ${resData.errorObj.msgDe}`);
        break;
      default:
        console.error("unknown websocket dataType:", event);
        alert("unknown websocket dataType:", resData.type);
    }
  };
  */

  function createSessionToken(userId) {
    let sessionToken = userId;
    let now = new Date();
    sessionToken += "-";
    sessionToken += now.getFullYear();
    sessionToken += "-";
    sessionToken += (now.getMonth() + 1) < 10 ? "0" + (now.getMonth() + 1): (now.getMonth() + 1);
    sessionToken += "-";
    sessionToken += now.getDate() < 10 ? "0" + now.getDate(): now.getDate();
    sessionToken += "-";
    sessionToken += now.getHours() < 10 ? "0" + now.getHours(): now.getHours();
    sessionToken += "-";
    sessionToken += now.getMinutes() < 10 ? "0" + now.getMinutes(): now.getMinutes();
    sessionToken += "-";
    sessionToken += now.getSeconds() < 10 ? "0" + now.getSeconds(): now.getSeconds();
    sessionToken += "-";
    sessionToken += now.getMilliseconds();
    return sessionToken;
  }

  function manuallyCheckRedirectFlowState(reqData) {
    fetch(`${config.urls.backend}/gc/manuallyCheckRedirectFlowState/`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        redirectFlowId: reqData.redirectFlowId,
        userId: reqData.userId,
        sessionToken: reqData.sessionToken
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.status == "success") {
          console.log(data.redirectFlow);
          state = 3;
          dispatch("newPaymentResult", { state: state });
        } else if (data.status == "error") {
          //Falls noch nicht vorhanden, nach 2s erneut anfragen
          console.log("manuallyCheckRedirectFlowState: Not validated yet")
          setTimeout(() => {
            manuallyCheckRedirectFlowState(reqData);
          }, 2000);
        } else {
          alert("Unknown manuallyCheckRedirectFlowStateResp status")
        }
      });
  }

  function startRedirectFlow() {
    //windowRef muss hier erstellt werden, da iOS die Erstellung in Async-Functions nicht erlaubt
    let windowRef = window.open(
      `${config.urls.backend}/gc/redirectStart/`,
      "Lastschriftmandat",
      "width=800,height=600"
    );

    sessionToken = createSessionToken(userId);

    fetch(`${config.urls.backend}/gc/startRedirectFlow/`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId: userId,
        sessionToken: sessionToken
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("redirectInfo", data);
        redirectFlowId = data.redirectId;
        redirectFlowUrl = data.redirectUrl;
        windowRef.location = redirectFlowUrl;

        manuallyCheckRedirectFlowState({
            redirectFlowId: redirectFlowId,
            userId: userId,
            sessionToken: sessionToken
        });
        state = 2;
        dispatch("newPaymentResult", { state: state });
      });
  }
</script>

<HeaderIntro
  mainText={"Zahlungsdetails"}
  subText={"Zur Zahlung der Bestellung benötigen wir ein Lastschriftmandat."}
/>

<div class="stateContainer">
  {#if state == 1}
    <p>
      Zum jetzigen Zeitpunkt bieten wir nur die Zahlung mittels SEPA
      Lastschriftmandat an, um den Rechnungsbetrag von deinem Bankkonto einzuziehen.
    </p>
    <p class="secondaryP">
      Um die Sicherheit deiner Zahlungsdaten zu gewährleisten, arbeiten wir mit
      dem Unternehmen "GoCardless" zusammen. Dabei handelt es sich um einen
      etablierten Zahlungsdienstleister, welcher auch die Zahlungen vieler
      großer Unternehmen abwickelt.
    </p>
    <button class="btn btn-specialOrange" on:click={startRedirectFlow}
      >Lastschriftmandat erteilen</button
    >
  {:else if state == 2}
    <p>
      Bitte fülle das Formular zur Erteilung des Lastschriftmandats aus. Sobald
      du deine Daten abgeschickt hast, geht es für dich in diesem Fenster
      weiter.
    </p>
    <LoadingSpinner />
    <hr/>
    <p>
      Falls du das Fenster versehentlich geschlossen hast, kannst du mit dem
      Button den Prozess neu starten.
    </p>
    <button class="btn btn-specialOrange"
      on:click={() => {
        state = 1;
        dispatch("newPaymentResult", { state: state });
      }}>Prozess neu starten</button
    >
  {:else if state == 3}
    <div class="checkIcon"><div>&check;</div></div>
    <p>
      Du hast uns erfolgreich ein Lastschriftmandat erteilt. Wir werden die
      Zahlung nach Bestellabschluss automatisch von deinem Bankkonto einziehen.
    </p>
  {:else if state == 4}
    <h2>Fehler</h2>
    <p>
      Leider ist bei der Erteilung des Lastschriftmandats ein Fehler
      aufgetreten:
    </p>
    <div class="alert alert-danger" role="alert">
      {errorMsg}
    </div>
  {:else if state == 5}
    <div class="checkIcon"><div>&check;</div></div>
    <p>Du hast uns bereits ein Lastschriftmandat erteilt.<br/>Klicke auf den "Weiter"-Button unten rechts, um fortzufahren.</p>
    <hr/>
    <p>Falls du ein anderes, neues Bankkonto hinterlegen willst, kannst du mit diesem Button ein weiteres Lastschriftmandat erteilen.</p>
    <button class="btn btn-specialOrange uglyAsFuck"
      on:click={() => {
        state = 1;
        dispatch("newPaymentResult", { state: state });
      }}>Neues Lastschriftmandat erteilen</button
    >
  {/if}
</div>

<style>

  .stateContainer {
    background: white;
    padding: 30px;
    max-width: 650px;
    margin: auto;
    border-radius: 10px;
    border: solid 2px rgba(0,0,0,0.2);
    box-shadow: 0 0 20px rgb(0 0 0 / 5%);
  }

  hr {
    margin: 2rem 0;
  }

  .checkIcon {
    font-size: 50px;
    width: 60px;
    height: 60px;
    margin: 10px auto 30px auto;
    border: solid 4px #2da12d;
    color: #2da12d;
    border-radius: 50%;
    text-align: center;
  }
  .checkIcon > div {
    transform: translateY(-10px);
  }
  .uglyAsFuck {
    background-color: white !important;
    color: #ec9600 !important;
    border: solid 4px !important;
    transform: scale(0.8) !important;
  }

  .secondaryP {
    font-size: 12px;
    padding: 0 30px;
    opacity: 0.5;
  }
</style>
